module.exports = __webpack_public_path__ + "img/02.548c9951.jpg";